// Görev Taşıma (RTDB → SQL, süper admin) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.taskMigration';

export const superAdminTaskMigrationGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Görev Taşıma nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Firebase RTDB\'deki görev verisini şirketlerin kendi SQL veritabanına aktarırsınız. Önce tarayıp ne taşınacağını görün, sonra taşıyın. Taşıma geri alınamaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Görev Taşıma (RTDB → SQL)'),
    form: t(`${G}.regions.form`, 'Toplu Taşıma (Tüm Şirketler)'),
    list: t(`${G}.regions.list`, 'Tek şirket: seç, önizle, taşı'),
    footer: t(`${G}.regions.footer`, 'Sonuç'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Ne taşınır?'),
      text: t(`${G}.s1.text`, 'Tekil, günlük, haftalık ve aylık görevler; tamamlama ve kaçırma kayıtları; yorumlar; görev grupları; ekip projeleri ve yıllık planlar şirketin SQL veritabanına yazılır. Personel bağlantıları Firebase UID ile korunur; görev fotoğrafları Storage\'da kalır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Bu geçici bir araçtır: görevler çoğunlukla mobilden RTDB\'ye yazıldığı için, mobil SQL\'e geçtikten sonra araç son bir kez daha çalıştırılmalıdır.'),
        t(`${G}.s1.tip2`, '"Taşı" düğmelerini yalnız süper admin kullanabilir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Toplu taşıma: önce tara, sonra taşı'),
      text: t(`${G}.s2.text`, '"1) Tüm Şirketleri Tara (Görevleri Bul)" tüm şirketlerin görevlerini sayar; bu aşamada hiçbir şey yazılmaz. Tarama bitince özet kartları (verisi olan şirket, görev tipleri, tamamlanan / kaçırılan) görünür ve "2) Tümünü Taşı" düğmesi açılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Her şirket bitince ilerleme çubuğu ve canlı log güncellenir; aynı satırlar tarayıcı konsoluna da yazılır.'),
        t(`${G}.s2.tip2`, 'Hata veren şirket atlanır, diğerleri devam eder; sonunda hatalı şirketler Şirket ID ve hata metniyle listelenir. Düzeltip toplu taşımayı yeniden çalıştırabilirsiniz.'),
        t(`${G}.s2.tip3`, 'Şirket sayısına göre uzun sürebilir; taşıma sürerken sayfayı kapatmayın. Taşıma tarayıcıdan şirket şirket yürütülür; sayfa kapanırsa kalan şirketler taşınmaz.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Tek şirket: seçin ve önizleyin'),
      text: t(`${G}.s3.text`, '"Şirket ara / seç" kutusundan şirketi seçin ve "Tara (Önizle)" düğmesine basın. Önizlemede görev tipleri ile tamamlama, slot, yorum, grup ve ekip sayıları görünür. Tarama hiçbir şey yazmaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Eşleşen görevi bulunamayan (silinmiş görevlere ait) tamamlama kayıtları atlanır; önizlemede sayısı belirtilir.'),
        t(`${G}.s3.tip2`, 'Şirkette taşınacak görev verisi yoksa "SQL\'e Taşı" düğmesi kapalı kalır.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Taşıyın: bu işlem geri alınamaz'),
      text: t(`${G}.s4.text`, '"SQL\'e Taşı" → onay penceresinde "Taşı" ile şirketin görevleri SQL\'e yazılır. Geri alma düğmesi yoktur: SQL\'de zaten olan kayıtlar RTDB\'deki verilerle güncellenir (üzerine yazılır), olmayanlar eklenir. Taşımadan önce önizlemedeki sayıları kontrol edin.'),
      tips: [
        t(`${G}.s4.tip1`, 'Tekrar çalıştırmak güvenlidir (idempotent): aynı kayıt ikinci kez eklenmez, yalnız güncellenir. Ancak SQL\'de sonradan yapılan değişiklikler RTDB\'deki eski değerle ezilebilir.'),
        t(`${G}.s4.tip2`, 'RTDB\'deki veriler silinmez; araç yalnız okur.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Sonucu okuyun'),
      text: t(`${G}.s5.text`, 'Sonuç tablosu her tür için Eklendi, Güncellendi ve Hata sayısını gösterir. Toplu taşımada kartlarda "+eklenen / ~güncellenen" biçiminde toplamlar görünür.'),
      tips: [
        t(`${G}.s5.tip1`, 'Orphan personel uid: görevdeki personel merkezi kullanıcı listesinde (SystemUsers) bu şirkete bağlı bulunamadı. Görev yine de yazılır; kullanıcı taşıması tamamlanınca aracı tekrar çalıştırın.'),
      ],
    },
  ],
});
